module.exports = __webpack_public_path__ + "img/fsma_afm.077e836b.jpg";